module.exports = __webpack_public_path__ + "img/LogoImage_example.6ecbfe33.jpg";